export enum Frequency {
    Annually = '4',
    Daily = '1',
    Monthly = '3',
    Quarterly = '5',
    Weekly = '2'
}
